import { render } from "./WidgetComponent.vue?vue&type=template&id=6a445f72"
import script from "./WidgetComponent.vue?vue&type=script&lang=js"
export * from "./WidgetComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__